import React from "react";

function SelfHelpIcon(props) {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          overflow="hidden"
          viewBox="0 0 183 179"
          {...props}
        >
          <path
            className="fill-current"
            fillRule="evenodd"
            stroke="#FFF"
            strokeMiterlimit="8"
            strokeWidth="13.75"
            d="M11 89C11 44.265 47.713 8 93 8s82 36.265 82 81-36.713 81-82 81-82-36.265-82-81z"
          ></path>
          <g fill="#FFF">
            <path d="M96.733 57.5A12.795 12.795 0 0083.9 44.667 12.795 12.795 0 0071.067 57.5c0 3.617 1.516 7 4.083 9.45v-6.183c-1.75-4.784.7-10.15 5.483-12.017 4.784-1.867 10.15.7 12.017 5.483a9.016 9.016 0 010 6.534v6.066C95.217 64.5 96.733 61 96.733 57.5z"></path>
            <path d="M83.9 37.667c-10.967 0-19.833 8.866-19.833 19.833 0 7.583 4.316 14.467 11.083 17.85v-3.967c-7.583-4.783-9.917-14.933-5.017-22.516 4.9-7.584 14.817-10.034 22.517-5.134 7.7 4.9 9.917 14.934 5.017 22.517a17.16 17.16 0 01-5.017 5.017v3.966c9.8-4.783 13.883-16.683 9.1-26.483-3.383-6.767-10.383-11.083-17.85-11.083z"></path>
            <path d="M78.65 57.5v50.983L74.217 89c-.7-2.8-3.5-4.55-6.3-3.967-2.8.7-4.55 3.384-3.967 6.184l6.3 28.466c.233 1.167.933 2.334 1.983 3.034L83.9 131.7v7.933h30.567V134.5c0-7.467 8.4-8.05 8.4-22.167V93.317c0-3.5-2.8-6.3-6.3-6.3-1.634 0-3.15.583-4.317 1.633v-.583c0-3.5-2.8-6.3-6.3-6.3-1.633 0-3.267.583-4.433 1.75-.817-3.384-4.2-5.6-7.584-4.784-2.916.7-4.9 3.15-4.9 6.067h-.116V57.5a5.228 5.228 0 00-5.25-5.25c-2.684 0-5.017 2.333-5.017 5.25z"></path>
          </g>
        </svg>
    );
}

export default SelfHelpIcon;
